import React, { useState } from "react";
import { useSelector } from "react-redux";
import GS_Central_Data_Collection_Forms from "./GS_Central_Data_Collection_Forms";
import GS_OdkInfo from "./GS_OdkInfo";

function GS_DataCollection({userWantInfoAgain,setUserWantInfoAgain}) {
  const user = useSelector((state) => state.userInfo);
  console.log(userWantInfoAgain)
  return (
    <>
      {userWantInfoAgain ? (
        <GS_OdkInfo userWantInfoAgainFn={setUserWantInfoAgain} userWantInfoAgain={userWantInfoAgain}/>
      ) : user?.isTrialFormCompleted ? (
        <GS_Central_Data_Collection_Forms userWantInfoAgain={setUserWantInfoAgain}/>
      ) : (
        <GS_OdkInfo userWantInfoAgainFn={setUserWantInfoAgain} userWantInfoAgain={userWantInfoAgain}/>
      )}
    </>
  );
}

export default GS_DataCollection;
